import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import { useStore } from 'vuex'

export default {
    name: 'FormStepZero',
    props: _stafetCommonStepsProps,
    setup() {
        const store = useStore()

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'formStepZero',
                labelKey: labelKey
            })

        return {
            getLabel
        }
    }
}
